export const imagesMixin = {
  methods: {
    // @vuese
    // Sprawdzanie typu zdjęć
    images(imgs: Array<String> | String): Array<String> {
      if (Array.isArray(imgs)) {
        return imgs;
      } else if (imgs) {
        return imgs
          .split(',')
          .map(image => image.trim())
          .filter(x => !!x);
      }
      return [];
    },
    // @vuese
    // Zwracanie pierwszego zdjęcia z tablicy
    firstImage(imgs: Array<String> | String): String {
      const images = this.images(imgs);
      return images[0];
    }
  }
};
